<template>
  <gas-page-shell :breadcrumb="['组织管理', '配额设置']">
    <el-form :inline="true" :model="query" size="small" class="search-form">
      <el-form-item label="所属机构">
        <el-select v-model="query.orgId" clearable placeholder="全部机构" style="width:160px">
          <el-option v-for="o in orgOptions" :key="o.orgId" :label="o.orgName" :value="o.orgId" />
        </el-select>
      </el-form-item>
      <el-form-item label="关键词"><el-input v-model="query.keyword" clearable placeholder="备注" /></el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">查询</el-button>
        <el-button @click="resetQuery(() => { query.orgId = null })">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="toolbar table-title-row">
      <div class="table-title-group">
        <span class="table-title">配额列表 <em>共 {{ total }} 条记录</em></span>
        <gas-table-toolbar
          :columns="tableColumnDefs"
          :visible-map.sync="tableColumnVisible"
          :selected-count="selectedIds.length"
          :show-batch-delete="tableCanBatchDelete"
          @batch-delete="batchRemove"
        />
      </div>
      <el-button type="primary" size="small" icon="el-icon-plus" @click="openCreate(emptyForm())">新增配额</el-button>
    </div>
    <el-table :data="list" v-loading="loading" border size="small" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="44" align="center" />
      <el-table-column label="所属机构" min-width="140">
        <template slot-scope="{ row }">{{ orgName(row.orgId) }}</template>
      </el-table-column>
      <el-table-column prop="maxTerminals" label="终端上限" width="100" />
      <el-table-column prop="maxDevices" label="设备上限" width="100" />
      <el-table-column prop="usedTerminals" label="已用终端" width="100" />
      <el-table-column prop="usedDevices" label="已用设备" width="100" />
      <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip />
      <el-table-column prop="updateTime" label="更新时间" min-width="150" />
      <el-table-column label="操作" width="140" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" size="small" @click="openEdit(row, emptyForm())">编辑</el-button>
          <el-button type="text" size="small" class="danger" @click="removeRow(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pager" background layout="total, sizes, prev, pager, next"
      :total="total" :current-page="query.pageNum" :page-size="query.pageSize"
      :page-sizes="[10,20,50]" @size-change="handleSizeChange" @current-change="handleCurrentChange" />

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="560px">
      <el-form :model="form" label-width="100px" size="small">
        <el-form-item label="所属机构">
          <el-select v-model="form.orgId" style="width:100%">
            <el-option v-for="o in orgOptions" :key="o.orgId" :label="o.orgName" :value="o.orgId" />
          </el-select>
        </el-form-item>
        <el-form-item label="终端上限"><el-input v-model.number="form.maxTerminals" /></el-form-item>
        <el-form-item label="设备上限"><el-input v-model.number="form.maxDevices" /></el-form-item>
        <el-form-item label="已用终端"><el-input v-model.number="form.usedTerminals" /></el-form-item>
        <el-form-item label="已用设备"><el-input v-model.number="form.usedDevices" /></el-form-item>
        <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="2" /></el-form-item>
      </el-form>
      <span slot="footer"><el-button @click="dialogVisible=false">取消</el-button><el-button type="primary" @click="submitForm">保存</el-button></span>
    </el-dialog>
  </gas-page-shell>
</template>

<script>
import GasPageShell from '@/components/GasPageShell.vue'
import gasCrudPage from '@/mixins/gasCrudPage'
import { gasApi } from '@/api/gas'

const emptyForm = () => ({ maxTerminals: 0, maxDevices: 0, usedTerminals: 0, usedDevices: 0 })

export default {
  components: { GasPageShell },
  mixins: [gasCrudPage],
  data() {
    return {
      loadOrgOptions: true,
      idField: 'quotaId',
      listApi: gasApi.quota.list,
      saveApi: gasApi.quota.save,
      removeApi: gasApi.quota.remove,
      batchRemoveApi: gasApi.quota.batchRemove,
      query: { pageNum: 1, pageSize: 10, keyword: '', orgId: null }
    }
  },
  methods: {
    emptyForm,
    async submitForm() {
      if (!this.form.orgId) return this.$message.warning('请选择所属机构')
      await gasCrudPage.methods.submitForm.call(this)
    }
  }
}
</script>

<style scoped>
.toolbar { margin-bottom:12px; display:flex; gap:8px; }
.search-form { margin-bottom:8px; }
.pager { margin-top:16px; text-align:right; }
.danger { color:#f53f3f; }
</style>
